/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import Header from "../../../components/common/layout/Header";
import Banner from "../../../components/passenger/stores/Banner";
import { useEffect, useState } from "react";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import AllStores from "../../../components/passenger/stores/AllStores";

const Stores = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [category, setCategory] = useState<any>(null)
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [categoryLoading, setCategoryLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [isCategoryError, setIsCategoryError] = useState<boolean>(false)
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const { t } = useTranslation('common');
    useSitemap();

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    const getCategory = async () => {
        try {
            setCategoryLoading(true)
            setIsCategoryError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.store_category}${!!debouncedValue ? `?search=${debouncedValue}` : ""}`);

            if (res && res?.status === 200) {
                setCategory(res?.data)
                setCategoryLoading(false);
            }
        } catch (error) {
            setIsCategoryError(true)
            setCategoryLoading(false)
            console.error("error while feching category data", error);
        }
    };

    const getStores = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.stores}${!!debouncedValue ? `?search=${debouncedValue}` : ""}`);

            if (res && res?.status === 200) {
                setData(res?.data)
                setLoading(false);
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while feching stores data", error);
        }
    };

    useEffect(() => {
        !!lang && getCategory();
        !!lang && getStores();
    }, [lang, debouncedValue])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.stores.title")}</title>
                <meta name="description" content={t("seo_friendly.stores.desc")} />
            </Helmet>
            <div className="w-full h-full relative bg-white dark:bg-bgDarkDull">
                <div className="w-full stores-bg relative h-full">
                    <img src={require('../../../assets/images/pattern4.png')} alt="pattern" className="absolute bottom-0 left-0 flex items-start justify-start h-full" />
                    <div className="relative z-[1]">
                        <Header type="passenger" />
                        <Banner setData={setData} setSearch={setSearch} search={search} />
                    </div>
                </div>

                <div className="w-full h-full container" id="home">
                    <AllStores data={data} loading={loading} setSearch={setSearch} search={search} isError={isError} isCategoryError={isCategoryError} categoryLoading={categoryLoading} category={category} />
                </div>
            </div>
        </>
    );
};

export default Stores;